export const errors = {
    errorOccured: ['Произошла ошибка. Пожалуйста, повторите попытку позже', 'Error occurred. Please try again later'],
    failedLoadData: ['Не удалось загрузить данные. Пожалуйста, повторите попытку позже!', 'Failed download data. Please try again later!'],
    getData: [
        'Не удалось получить данные с сервера. Пожалуйста, попробуйте позже!',
        'Failed to get data from the server. Please try again later!',
    ],
    getUserData: ['Сбой в работе пользовательских данных', 'Failed user data'],
    incorrectLogin: ['Неверное имя пользователя или пароль', 'Incorrect username or password'],
    incorrectPass: ['Неверный пароль', 'Incorrect password'],
    incorrectUserPass: [
        'Неверный пароль пользователя, пожалуйста, повторите попытку позже',
        'Incorrect user password, please try again later',
    ],
    logoutErr: ['Ошибка выхода из системы. Пожалуйста, повторите попытку позже', 'Logout error. Please try again later'],
    noAccess: ['Нет доступа к приложению. Проверьте свой аккаунт.', 'No access to the application. Check your account.'],
    noConnection: ['Нет подключения к серверу', 'There is no connection to the server'],
    openFile: ['Не удается открыть файл. Возможно, он не загружен.', "Can't open a file. Maybe it is not loaded."],
    removeFileUnexpectedErr: [
        'Произошла непредвиденная ошибка. Не удалось удалить файлы',
        'An unexpected error occurred. Failed to remove the files',
    ],
    removeFile: ['Системная ошибка. Не удается удалить файл.', 'System error. Can not remove the file.'],
    sendData: ['Ошибка при отправке данных. Пожалуйста, повторите попытку позже', 'Sending data error. Please try again later'],
    sendFileError: ['Файл не отправлен. Подробности: {{message}}', 'File not sent. Details: {{message}}'],
    showTelegram: ['Не удается отобразить телеграмму. Пожалуйста, повторите попытку позже', 'Cannot show telegram. Please try again later'],
    signTelegram: ['Не удается подписать телеграмму. Пожалуйста, повторите попытку позже', 'Cannot sign telegram. Please try again later'],
    somethingWrong: ['Что-то пошло не так', 'Something went wrong'],
    stateFileNotSent: ['Файл состояния {{fileName}} не отправлен', 'State file {{fileName}} not sent'],
    uploadDocument: [
        'Документ не был загружен правильно. Пожалуйста, попробуйте позже!',
        'The document was not uploaded correctly. Please try again later!',
    ],
    uploadDocuments: [
        'Не все документы были загружены правильно. Пожалуйста, попробуйте позже!',
        'Not all the documents have been uploaded correctly. Please try again later!',
    ],
    validation: ['Ошибка валидации', 'Validation error'],

    title: {
        delete: ['Ошибка удаления', 'Delete error'],
        logout: ['Ошибка выхода из системы', 'Logout error'],
        sending: ['Ошибка отправки', 'Sending error'],
        showTelegram: ['Ошибка в отображении телеграммы', 'Show telegram error'],
        signTelegram: ['Ошибка в подписи телеграммы', 'Sign telegram error'],
    },

    validate: {
        dateTimeRequired: ['Дата и время - обязательные поля', 'Date and Time is required fields'],
        dateToMustLaterFrom: ['Дата "До" должна быть позже даты "От"', 'Date To must be later than date From.'],
        enterField: ['Заполните поле {{title}}', 'Enter the field {{title}}'],
        fieldIncorrect: ['Поле {{title}} заполнено неверно', 'Field {{title}} is incorrect'],
        fieldIsIncorrect: ['Поле заполнено неверно', 'Field is incorrect'],
        fieldIsRequired: ['Заполните поле', 'Field is required'],
        fieldLeastSymbols: [
            'Поле {{title}} должно содержать не менее {{min}} символов',
            'Field {{title}} must contain at least {{min}} symbols',
        ],
        fieldMoreSymbols: [
            'Поле {{title}} должно содержать не более {{max}} символов',
            'Field {{title}} must contain no more than {{max}} symbols',
        ],
        fieldNotType: ['Поле {{title}} не является "{{type}}"', 'Field {{title}} is not a "{{type}}"'],
        fieldNotValid: ['Поле недействительно', 'Field is not valid'],
        formatLatitude: ['Формат N1234.1', 'Format N1234.1'],
        formatLongitude: ['Формат E12345.1', 'Format E12345.1'],
        isRequired: ['Обязательное', 'Is required'],
        lengthRange: ['Диапазон длины [{{minLength}};{{maxLength}}]', 'Length range is [{{minLength}};{{maxLength}}]'],
        maxLength: ['Максимальная длина: {{length}}', 'Max length is {{length}}'],
        maxPrecision: ['Максимальная точность: {{max}}', 'Max precision is {{max}}'],
        range: ['Диапазон значений: [{{min}};{{max}}]', 'Value range is [{{min}};{{max}}]'],
    },
};
